export const MICA_REDIRECT_PATH = "/redirect-mica";
export const MICA_SIMULATOR_PATH = "/whatsapp-chat-simulator";

export const MICA_DEFAULT_MESSAGE = "Volviendo a Mica";
export const MICA_PAYMENT_SUCCESS_MESSAGE = "Listo, ya pagué!";
export const MICA_CONNECT_SUCCESS_MESSAGE = "Listo, ya conecté mi cuenta!";

export const ALLOWED_MICA_REDIRECT_QUERY_KEYS = new Set([
  "message",
  "status",
  "subscription",
  "session_id",
]);

export const MAX_MICA_MESSAGE_LENGTH = 500;

export const sanitizeMicaMessage = (
  message,
  fallback = MICA_DEFAULT_MESSAGE
) => {
  const sanitized = String(message || fallback)
    .trim()
    .slice(0, MAX_MICA_MESSAGE_LENGTH);
  return sanitized || fallback;
};

export const buildMicaRedirectPath = (message, extraQuery = {}) => {
  const params = new URLSearchParams();
  params.set("message", sanitizeMicaMessage(message));

  Object.entries(extraQuery).forEach(([key, value]) => {
    if (!ALLOWED_MICA_REDIRECT_QUERY_KEYS.has(key)) return;
    if (key === "message") return;
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });

  return `${MICA_REDIRECT_PATH}?${params.toString()}`;
};

export const buildMicaSimulatorPath = (message) => {
  const params = new URLSearchParams();
  params.set("prefill", sanitizeMicaMessage(message));
  return `${MICA_SIMULATOR_PATH}?${params.toString()}`;
};

export const buildMicaWhatsAppUrl = (message) => {
  const number = String(import.meta.env.VITE_WACM_WHATSAPP_NUMBER || "").trim();
  if (!number) return null;
  const digits = number.replace(/\D/g, "");
  if (!digits) return null;
  const text = encodeURIComponent(sanitizeMicaMessage(message));
  return `https://wa.me/${digits}?text=${text}`;
};

export const resolveMicaRedirectDestination = (searchParams) => {
  const message = sanitizeMicaMessage(searchParams.get("message"));
  return buildMicaWhatsAppUrl(message);
};
